// Centralized environment configuration.
// All env var access should go through this module so missing
// values are caught early and typed constants are available everywhere.

function requireEnv(key: string): string {
  const value = process.env[key];
  if (!value) {
    console.error(`Missing required environment variable: ${key}`);
  }
  return value || '';
}

export const config = {
  supabase: {
    url: requireEnv('REACT_APP_SUPABASE_URL'),
    anonKey: requireEnv('REACT_APP_SUPABASE_ANON_KEY'),
  },
  api: {
    baseUrl: requireEnv('REACT_APP_API_URL'),
  },
  cdn: {
    baseUrl: process.env.REACT_APP_CDN_URL || 'https://assets.easytocook.com.au',
  },
  app: {
    // Deep link scheme used to bounce users back into the native app after
    // a successful web subscription.
    deepLinkScheme: 'easytocook',
  },
  isDevelopment: process.env.NODE_ENV === 'development',
} as const;
